import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { vw } from '../../styles/theme'
import Footer from '../footer/Footer'

export type PageProps = BoxProps & {}

const Page: React.FC<PageProps> = ({ children, ...others }) => {
  return (
    <>
      <Box minW={['contentMinWSP', 'contentMinWPC']} pb={[vw(346), '0']} {...others}>
        {children}
        <Footer />
      </Box>
    </>
  )
}

export default Page
